module.exports = __webpack_public_path__ + "img/rectangle.a6f9726.png";